import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImportPaymentRoutingModule } from './import-payment-routing.module';
import { ImportPaymentComponent } from './import-payment.component';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { MyDatePickerModule } from 'mydatepicker';


@NgModule({
  declarations: [ImportPaymentComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    GridModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    MyDatePickerModule,
    DropDownListAllModule,
    ImportPaymentRoutingModule,
  ],
  providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService]
})
export class ImportPaymentModule { }
